declare var pm: PmInterface;

const animationDuration = 250;

const { findHtmlEl, getClosest } = pm.utils.dom;

export function openPopup(name: string, triggerButton?: HTMLElement) {
	const popup = findHtmlEl("." + name + "-popup");
	if (!popup) return;

	pm.event.emit("pm_popup_will_open", {
		name: name,
		popup,
		triggerButton,
	});

	const parentEl = popup.parentElement;
	const overlay = parentEl?.classList.contains("popup-overlay")
		? parentEl
		: null;

	// This is necessary because guidelines-popup has 350ms animation duration.
	const duration = overlay?.dataset.animationDuration
		? parseInt(overlay.dataset.animationDuration, 10)
		: animationDuration;

	if (overlay) {
		overlay.style.display = "flex";
		jQuery(overlay)
			.stop()
			.animate(
				{
					opacity: 1,
				},
				duration,
				() => {
					pm.openedPopups[name] = Date.now();
				},
			);

		return;
	}

	// If overlay is not found, just show the popup using slideUp effect from bottom of the page to 20px from bottom.
	jQuery(popup)
		.stop()
		.animate(
			{
				bottom: "20px",
			},
			// We don't use duration + 100 because all closing animations are in 350ms.
			animationDuration + 100,
			() => {
				pm.openedPopups[name] = Date.now();
			},
		);
}

export function closePopup(name: string) {
	const popup = findHtmlEl("." + name + "-popup");
	if (!popup) return;

	pm.event.emit("pm_popup_will_close", {
		name: name,
		popup,
	});

	const overlay = findHtmlEl("." + name + "-popup-overlay");

	if (overlay) {
		jQuery(overlay)
			.stop()
			.animate(
				{
					opacity: 0,
				},
				animationDuration,
				() => {
					overlay.style.display = "none";
					delete pm.openedPopups[name];
				},
			);

		return;
	}

	jQuery(popup)
		.stop()
		.animate(
			{
				bottom: "-100%",
			},
			animationDuration + 100,
			() => {
				delete pm.openedPopups[name];
			},
		);
}

export function setupOpenPopup(popupName: string) {
	document.addEventListener("click", (e) => {
		const target = e.target;
		if (!(target instanceof Element)) return;

		const button = getClosest(target, ".open-" + popupName + "-popup", 5);
		if (!button) return;

		e.preventDefault();

		const overlay = findHtmlEl("." + popupName + "-popup-overlay");
		const popup = findHtmlEl("." + popupName + "-popup");

		if (popup && overlay) {
			pm.event.emit("pm_popup_trigger_clicked", {
				name: popupName,
				popup: popup,
				overlay: overlay,
				triggerButton: button,
			});
		}

		openPopup(popupName, button);
	});
}

export function setupClosePopup(popupName: string) {
	document.addEventListener("click", (e) => {
		const target = e.target;
		if (!(target instanceof Element)) return;

		const trigger = getClosest(target, ".open-" + popupName + "-popup", 5);
		if (trigger) return;

		const popup = getClosest(target, "." + popupName + "-popup", 30);
		if (popup) return;

		const overlay = getClosest(target, "." + popupName + "-popup-overlay", 30);
		if (overlay?.classList.contains("unclosable")) return;

		if (overlay) {
			closePopup(popupName);
		}
	});

	document.addEventListener("keydown", (e: KeyboardEvent) => {
		const key = e.key.toLowerCase();

		if (key !== "escape" && key !== "esc") {
			return;
		}

		if (!Object.keys(pm.openedPopups).length) {
			return;
		}

		// Get item from openedPopups object that has the highest timestamp.
		const lastOpenedPopup = Object.entries(pm.openedPopups)
			.sort((a, b) => b[1] - a[1])
			.shift();

		const lastOpenedPopupName = lastOpenedPopup?.[0];

		if (lastOpenedPopupName && lastOpenedPopupName === popupName) {
			const overlay = findHtmlEl("." + lastOpenedPopupName + "-popup-overlay");
			if (overlay?.classList.contains("unclosable")) return;

			closePopup(lastOpenedPopupName);
		}
	});

	document.addEventListener("click", (e) => {
		const target = e.target;
		if (!(target instanceof Element)) return;

		const closeButton = getClosest(target, ".close-popup", 5);
		if (!closeButton) return;

		const overlay = findHtmlEl("." + popupName + "-popup-overlay");
		if (overlay?.classList.contains("unclosable")) return;

		const popup = getClosest(closeButton, "." + popupName + "-popup", 10);
		if (!popup) return;

		closePopup(popupName);
	});
}
